var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/easy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/easy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happy-outline",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.90384615,
    cy: 7.63461538,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50180288,13.1153846 C6.8640625,13.1153846 5.48665865,12.050601 5.05072115,10.597476 C5.02599948,10.5097925 5.04415174,10.4155837 5.09968382,10.3433636 C5.1552159,10.2711435 5.24160069,10.2294006 5.33269231,10.2307692 L11.6676683,10.2307692 C11.7587599,10.2294006 11.8451447,10.2711435 11.9006768,10.3433636 C11.9562088,10.4155837 11.9743611,10.5097925 11.9496394,10.597476 C11.5173077,12.050601 10.1395433,13.1153846 8.50180288,13.1153846 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.0961538,
    cy: 7.63461538,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/easy",
    transform: "translate(0.423077, 0.423077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07692308,1.77635684e-14 C3.61616164,1.77635684e-14 -2.09610107e-13,3.61616164 -2.09610107e-13,8.07692308 C-2.09610107e-13,12.5376845 3.61616164,16.1538462 8.07692308,16.1538462 C12.5376845,16.1538462 16.1538462,12.5376845 16.1538462,8.07692308 C16.1538462,3.61616164 12.5376845,1.77635684e-14 8.07692308,1.77635684e-14 Z M8.07692308,1.15384615 C11.9004329,1.15384615 15,4.25341327 15,8.07692308 C15,11.9004329 11.9004329,15 8.07692308,15 C4.25341327,15 1.15384615,11.9004329 1.15384615,8.07692308 C1.15384615,4.25341327 4.25341327,1.15384615 8.07692308,1.15384615 Z",
    id: "Oval"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.dc23d98b6de645a43eec1dcb7bdf98ec.svg";
export { ForwardRef as ReactComponent };